<template>
  <div>
    <v-row v-for="(suggestion, idx) in suggestionsList" :key="idx" no-gutters>
      <the-suggestion
        :dataSourceName="dataSourceName"
        :featureId="featureId"
        :layer-id="layerId"
        :suggestion="suggestion"
      />
    </v-row>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

import TheSuggestion from '@/components/TheSuggestion';

export default {
  name: 'SuggestionsList',
  components: { TheSuggestion },
  props: {
    dataSourceName: {
      type: String,
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
    layerId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    suggestions: get('suggestions/suggestions'),
    suggestionsList() {
      return this.suggestions || [];
    },
  },
};
</script>
